// Copyright © 2022 Move Closer
export const FormRepositoryType = Symbol.for('IFormRepository');
